import React from 'react';

export const MENU_ITEM_TOOLTIP = (
  <div className="text-white">
    <div className="font-medium">Highlight mode on:</div>
    <div>
      Select text to create a<br /> highlight automatically.
    </div>
  </div>
);

export const HIGHLIGHT_COLORS_NAMES = {
  YELLOW: 'bluebook-yellow',
  BLUE: 'bluebook-blue',
  RED: 'bluebook-red',
};
